import { Component, inject, signal, computed, OnDestroy, viewChild } from '@angular/core';
import { RouterOutlet, Router, ActivationStart } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Header } from '@shells/app/header/header';
import { Sidebar } from '@shells/app/sidebar/sidebar';
import { Loader } from '@shared/components/loader/loader';
import { LoadingService } from '@core/loading/loading.service';
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-app-shell',
  imports: [
    Header,
    Sidebar,
    RouterOutlet,
    Loader,
    TranslatePipe,
    MatSidenavModule,
    RouterOutlet
  ],
  templateUrl: './app-shell.html',
  styleUrls: ['./app-shell.scss'],
})
export class AppShell implements OnDestroy {
  private readonly isMobile = signal(window.innerWidth <= 768);
  private readonly router = inject(Router);
  protected readonly matSidenav = viewChild(MatSidenav);
  protected readonly loading = inject(LoadingService);
  protected readonly showSidebar = computed(() => !this.isMobile());

  constructor() {
    window.addEventListener('resize', this.setIsMobile.bind(this));

    this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart && this.isMobile() && this.matSidenav()?.opened) {
        this.toggleSidebar();
      }
    });
  }

  setIsMobile() {
    this.isMobile.set(window.innerWidth <= 768);
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.setIsMobile.bind(this));
  }

  toggleSidebar() {
    this.matSidenav()?.toggle();
  }
}
